<!-- Modals -->
<app-deprecated-modal-form
    #createFeedbackModal
    headerText="performance.feedback-index.createFeedback"
    (save)="createFeedback(feedbackForm.feedback, feedbackForm)"
>
    <app-form-feedback #feedbackForm [profile]="employee"></app-form-feedback>
</app-deprecated-modal-form>

<mat-menu #moreActionsMenu="matMenu">
    <button
        mat-menu-item
        type="ghost"
        *permission="createGoalPermission"
        (click)="$event.stopPropagation(); trackCreatingGoal()"
        [routerLink]="['/performance', 'goals', 'create']"
    >
        {{ 'performance.overview.createGoal' | translate }}
    </button>
    <button
        mat-menu-item
        *permission="createFeedbackPermission"
        (click)="$event.stopPropagation(); createFeedbackModal.show(); trackCreatingFeedback()"
        tooltip="performance.feedback-index.newFeedback"
    >
        {{ 'performance.feedback-index.createFeedback' | translate }}
    </button>
</mat-menu>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event">
        <div class="buttons">
            <ui-button type="ghost" [matMenu]="moreActionsMenu" *ngIf="canOpenMoreActionsMenu">
                {{ 'performance.overview.more' | translate }}
                <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <ui-button
                (click)="trackCreatingReview()"
                type="primary"
                [routerLink]="['/performance', 'reviews', 'create']"
                *permission="createReviewPermission"
            >
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'performance.overview.createReview' | translate }}
            </ui-button>
        </div>
    </app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content">
            <div class="table-spacer">
                <app-table
                    [useStickyHeader]="false"
                    [showOffset]="false"
                    [table]="reviewsTable"
                    [showSearch]="false"
                    title="{{ 'performance.overview.performanceDashboard.label' | translate }}"
                    class="table"
                >
                    <app-empty-state
                        [label]="
                            !reviewsTable.hasFiltersApplied()
                                ? 'performance.overview.performanceDashboard.noReviewsMessage'
                                : ''
                        "
                        src="/assets/illustrations/clipboard-star.png"
                    ></app-empty-state>
                </app-table>
            </div>

            <div class="table-spacer">
                <app-table
                    [useStickyHeader]="false"
                    [showOffset]="false"
                    [table]="goalsTable"
                    [showSearch]="false"
                    title="{{ 'performance.overview.goalChart.label' | translate }}"
                    class="table"
                >
                    <app-empty-state
                        [label]="!goalsTable.hasFiltersApplied() ? 'performance.overview.goalChart.noGoalsMessage' : ''"
                        src="/assets/illustrations/flag.png"
                    ></app-empty-state>
                </app-table>
            </div>

            <div class="table-spacer">
                <app-table
                    [useStickyHeader]="false"
                    [showOffset]="false"
                    [table]="feedbackTable"
                    [showSearch]="false"
                    title="{{ 'performance.feedback-index.mainTitle' | translate }}"
                    class="table"
                >
                    <app-empty-state
                        [label]="!feedbackTable.hasFiltersApplied() ? 'performance.feedback-index.noFeedback' : ''"
                        src="/assets/illustrations/clipboard-speech-bubble.png"
                    ></app-empty-state>
                </app-table>
            </div>
        </div>
    </div>
</div>
